/* eslint-disable */
const validateSettlementDetail = (formState) => {
  const form = {};
  Object.entries(formState).forEach(([key, val]) => {
    validateFields(key, formState, form);
  });

  return form;
};

const validateFields = (field, formState, form) => {
  switch (field) {
    case "paymentType":
      if (!formState.paymentType) {
        form.paymentType = "Required";
      }
      break;
    case "settleAmount":
      if (!formState.settleAmount) {
        form.settleAmount = "Required";
      }
      break;
  }
};

export default validateSettlementDetail;
